let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ipjH8")).then(() => parcelRequire('fyXPe'));